import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PhotoRepository, SuccessfulUpload } from "./photo-upload";

@Injectable({
	providedIn: "root"
})
export class PhotoUploadService
{
	private photoRepository: PhotoRepository;

	public constructor(photoRepository: PhotoRepository)
	{
		this.photoRepository = photoRepository;
	}

	public uploadFiles(files: FileList, path: string): Observable<SuccessfulUpload>
	{
		return this.photoRepository.uploadFiles(this.getFormData(files), path);
	}

	public getFormData(files: FileList): FormData
	{
		const formData: FormData = new FormData();
		Array.from(files).forEach((file: any) =>
		{
			formData.append("files", file, (file.name as string).replace(/ /g, "_"));
		});
		return formData;
	}
}
